import { gql } from '@apollo/client';

export type I18nConfigItem = {
  id: string;
  messageKey: string;
  popupType: number;
  triggerScene: string | null;
  titleZh: string | null;
  titleEn: string | null;
  titleEs: string | null;
  contentZh: string | null;
  contentEn: string | null;
  contentEs: string | null;
  remark: string | null;
  updatedBy: string;
  updatedAt: number;
};

export type I18nConfigFilterInput = {
  messageKey?: string;
  popupType?: number;
  triggerScene?: string;
  isDeleted?: boolean;
};

export type I18nConfigPageResponse = {
  getI18nConfigsWithPagination: {
    content: I18nConfigItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
};

export const GET_I18N_CONFIGS_WITH_PAGINATION = gql`
  query GetI18nConfigsWithPagination(
    $filter: I18nConfigFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    getI18nConfigsWithPagination(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        messageKey
        popupType
        triggerScene
        titleZh
        titleEn
        titleEs
        contentZh
        contentEn
        contentEs
        remark
        updatedBy
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
